
<template>
  <b-navbar type="light" variant="light" class="border-top d-none d-sm-block">
    <b-container fluid>
      <b-col><small class="text-center text-secondary">&copy; {{ year }} Hello Holidays </small></b-col>
      <b-col md="8 d-flex justify-content-center">
        <a href="http://www.helloholidays.ro" target="_blank"><img src="@/assets/images/logos/bg-logo2.png" alt="" height="25px"><small class="text-primary ml-2">www.helloholidays.ro</small></a>
      </b-col>
      <b-col sm="2">
        <div class="ml-auto text-right">
          <img src="@/assets/images/logos/tripS-logo.svg" alt="" width="55%">
        </div>
      </b-col>
    </b-container>
  </b-navbar>
</template>

<script>

export default {
  data () {
    return {
      year: ''
    }
  },
  created () {
    this.year = new Date().getFullYear()
  }
}
</script>
